var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 81,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A5475",
    d: "M139.369 41.622a3.001 3.001 0 0 0 0-4.243l-19.092-19.092a3 3 0 0 0-4.243 4.243l16.971 16.97-16.971 16.97a3.001 3.001 0 0 0 4.243 4.243l19.092-19.091Zm-76.81.878h74.689v-6h-74.69v6Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 40.001,
    r: 38,
    fill: "#6BB97F",
    style: {
      fill: "#5abbdd",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartArrow);
export default __webpack_public_path__ + "static/media/start-arrow.fa3d86bcaa73a828cf55491459c16445.svg";
export { ForwardRef as ReactComponent };